import { List, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';
import FileGroupingFileSpecImportProcedureLookup from '../Models/Lookups/FileGroupingFileSpecImportProcedureLookup';
import ImportProcedureLookup from '../Models/Lookups/ImportProcedureLookup';
import ProcessTypeLookup from '../Models/Lookups/ProcessTypeLookup';
import GetImportProcedureListQuery from '../Models/Queries/GetImportProcedureListQuery';

@NeoModel
export default class ManageFileGroupingImportProcedureComponentVM extends Views.ViewModelBase {

    constructor(
        public fileGroupingFileSpecImportProceduresApiClient = AppService.get(Types.ApiClients.FileGroupingFileSpecImportProceduresApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public managedFileGroupingFileSpecImportProcedure = new FileGroupingFileSpecImportProcedureLookup();
    public getImportProceduresListQuery = new GetImportProcedureListQuery();

    public importProcedureList = new List(ImportProcedureLookup);
    public processTypeList = new List(ProcessTypeLookup);
    public isReadOnly = false;
    public disabled: boolean = true;

    public async initialise() {
        await this.populateProcessTypesList();
        if (this.managedFileGroupingFileSpecImportProcedure.importProcedureId !== null) {
            await this.populateImportProceduresList();
        }
        this.isReadOnly = this.managedFileGroupingFileSpecImportProcedure.fileGroupingFileSpecImportProcedureId !== null;
    }

    private async populateImportProceduresList() {
        this.getImportProceduresListQuery.managedProcedure.mapFrom(this.managedFileGroupingFileSpecImportProcedure);
        const response = await this.taskRunner.waitFor(this.fileGroupingFileSpecImportProceduresApiClient.getImportProcedures(this.getImportProceduresListQuery.toJSObject()));
        this.importProcedureList.set(response.data);
    }

    private async populateProcessTypesList() {
        const response = await this.taskRunner.waitFor(this.fileGroupingFileSpecImportProceduresApiClient.getProcessTypeList());
        this.processTypeList.set(response.data);
        if (this.managedFileGroupingFileSpecImportProcedure.fileGroupingFileSpecImportProcedureId !== null) {
            this.managedFileGroupingFileSpecImportProcedure.processTypeID = this.processTypeList.find(x => x.process === this.managedFileGroupingFileSpecImportProcedure.process)!.processTypeID;
            this.disabled = false;
        }
    }

    public async setSelectedProcess() {
        this.managedFileGroupingFileSpecImportProcedure.process = String(this.processTypeList.find(x => x.processTypeID === this.managedFileGroupingFileSpecImportProcedure.processTypeID)!.process);
        if (this.managedFileGroupingFileSpecImportProcedure.process !== null) {
            this.setImportProcedureTypeIndicators();
        }
        await this.taskRunner.waitFor(this.populateImportProceduresList());
        this.disabled = false;
    }

    private setImportProcedureTypeIndicators() {
        switch (this.managedFileGroupingFileSpecImportProcedure.process) {
            case TextConstants.ImportProcessTypes.Extraction:
                this.managedFileGroupingFileSpecImportProcedure.extractionInd = true;
                this.managedFileGroupingFileSpecImportProcedure.normaliseInd = false;
                this.managedFileGroupingFileSpecImportProcedure.dataInterceptionInd = false;
                break;
            case TextConstants.ImportProcessTypes.Interception:
                this.managedFileGroupingFileSpecImportProcedure.dataInterceptionInd = true;
                this.managedFileGroupingFileSpecImportProcedure.normaliseInd = false;
                this.managedFileGroupingFileSpecImportProcedure.extractionInd = false;
                break;
            case TextConstants.ImportProcessTypes.Normalise:
                this.managedFileGroupingFileSpecImportProcedure.normaliseInd = true;
                this.managedFileGroupingFileSpecImportProcedure.extractionInd = false;
                this.managedFileGroupingFileSpecImportProcedure.dataInterceptionInd = false;
                break;
        }
    }
}